import { css } from '@emotion/css';

export const surveyEditorContentStyles = css`
  max-width: 64.8rem;
`;

export const surveyBannerStyles = css`
  height: 25rem;
  margin-bottom: -8.6rem;
`;
